import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import { graphql } from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import useSiteSettings from '../../../../hooks/useSiteSettings'
import ScreenReaderOnly from '../../../ScreenReaderOnly'
import { StyledFunctionComponent } from '../../../types'
import * as Styled from './styled'

// add brand icons to library - might need to add specific icons instead for tree shaking
library.add(faFacebookF, faInstagram, faLinkedinIn, faTwitter, faYoutube)

const SocialMediaMenu: StyledFunctionComponent = ({ className }) => {
  const { footerSocialMenu: menuEntries } = useSiteSettings() || {}

  return (
    <ul className={className}>
      {menuEntries &&
        menuEntries.reduce((acc: React.ReactElement[], entry) => {
          if (!entry) return acc
          const { name: entryName, link } = entry
          const { href, blank } = link || {}
          if (!entryName || !href) return acc
          acc.push(
            <Styled.SocialMediaMenuEntry key={entryName}>
              <Styled.SocialMediaMenuLink to={href} target={blank != null ? '_blank' : undefined}>
                <ScreenReaderOnly>{entryName}</ScreenReaderOnly>
                <Styled.SocialMediaMenuIcon
                  icon={
                    typeof entry.icon === 'string' && entry.icon.startsWith('[')
                      ? JSON.parse(entry.icon)
                      : entry.icon
                  }
                />
              </Styled.SocialMediaMenuLink>
            </Styled.SocialMediaMenuEntry>,
          )
          return acc
        }, [])}
    </ul>
  )
}

const StyledSocialMediaMenu = styled(SocialMediaMenu)`
  display: flex;
  list-style: none;
  padding-left: 0;
  padding-top: 4px;
  background-color: ${({ theme }) => theme.colors.component.backgroundDarkBlue};
  flex-direction: row;
  justify-content: center;
  margin: 0 auto 2rem;
  box-sizing: border-box;
`

export { StyledSocialMediaMenu as SocialMediaMenu }

export const footerSocialMenu = graphql`
  fragment footerSocialMenuFragment on SanitySiteSettings {
    footerSocialMenu {
      name
      icon
      link {
        href
        blank
      }
    }
  }
`
